import { createStore } from 'vuex'
import banners from './banners'
import dataset from './dataset'
import requests from './requests'
import drafts from './drafts'
import schemas from './schemas.js'
import vrio from './vrio.js'

export default createStore({
  state: {
    error: null,
    success: null,
    isLoading: false,
  },
  mutations: {
    setStateProps(state, payload) {
      state[payload.prop] = payload.value
    },
  },
  actions: {
    showError({ state }, error) {
      state.error = error
    },
    hideError({ state }) {
      state.error = null
    },
    /**
     * @param {{text: string, btnText: string, onClick?: function}} payload
     */
    showSuccess({ state }, payload) {
      state.success = payload
    },
    hideSuccess({ state }) {
      state.success = null
    },
  },
  modules: {
    banners,
    dataset,
    requests,
    drafts,
    schemas,
    vrio,
  },
})
